















import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListTile from '@/types/components/IListTile.interface'
import Vue from 'vue'
interface DataItem {
    title: string
    icon: string
    value: string
}
export default Vue.extend({
    props: {
        //  Determines if our list has all the items, or a stepper
        inline: {
            type: Boolean,
            default: false
        },
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            el: 1,
            dataItems: [
                {
                    title: 'QuickBooks Online',
                    icon: 'mdi-link-variant',
                    value: 'QBO'
                },
                {
                    title: 'Xero',
                    icon: 'mdi-link-variant',
                    value: 'XERO'
                }
            ],
            items: [
                {
                    title: 'Select Data Source',
                    icon: 'mdi-link',
                    value: 'source'
                },
                {
                    title: 'CSV',
                    icon: 'mdi-database',
                    value: 'CSV'
                }
            ]
        }
    },
    mounted() {
        //  Set our current stepper step to the prop
        this.el = this.step
    },
    computed: {
        allItems(): DataItem[] {
            //  Combine all of our items EXCEPT our "Select Data Source" item
            return [...this.items, ...this.dataItems].slice(1)
        },
        dataItemsFiltered(): DataItem[] {
            //  Grab the tenants data provider
            const provider = this.$store.getters.tenant.data_provider

            //  If the provider is null, just return our data items so they can pick a provider
            if (provider === null) return this.dataItems

            //  Else, we only add the item related to their current provider
            const filtered = this.dataItems.find((x: DataItem) => x.value === provider)

            //  Return our filtered items
            return filtered
        }
    },
    methods: {
        dataItemIcon(item: DataItem): IListIcon {
            //  Grab our icon from the item
            const icon = item.icon

            //  Create our list icon
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our created icon
            return listIcon
        },
        goToDataSource(item: DataItem): void {
            const route = item.value === 'QBO' ? '/qbo' : '/xero'

            //  Tell our parent just in case
            this.$emit('onNavigation', route)

            //  Close the app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Navigate to the proper route
            this.$router.push(route)
        },
        goToDataProvider(item: DataItem): void {
            //  If our item value is CSV then just navigate there
            if (item.value === 'CSV') {
                //  Tell our parent just in case
                this.$emit('onNavigation', '/csv/import')
                //  Closes the current dialog
                this.$store.dispatch('dialogClose', 'APP')
                //  Navigates to our route
                this.$router.push('/csv/import')
            }

            //  Else, check if we are inline and if so, we want to go to that item
            else if (this.inline) this.goToDataSource(item)
            //  Else, we just go to the next item in our stepper
            else this.el = 2
        },
        tile(): IListTile {
            return {
                leftIcon: (item: DataItem) => this.dataItemIcon(item),
                line1: (item: DataItem) => item.title,
                callback: (item: DataItem) =>
                    this.el === 1
                        ? this.goToDataProvider(item)
                        : this.goToDataSource(item)
            }
        }
    }
})
